/** Form shape for the new-customer onboarding intake wizard (Customer Management, Demo Mode
 * only). Mirrors the tab grouping in `../index.tsx`: customer profile, service & catering
 * requirements, commercial & compliance. */
export interface CustomerIntakeForm {
  // Customer profile
  name: string;
  sector: string;
  operatingModel: string;
  owner: string;
  sitesCount: number | '';
  targetGoLive: string;

  // Service & catering requirements
  userTypes: string[];
  serviceTimes: string[];
  menus: string[];
  dietaryRequirements: string[];
  allergens: string[];
  hospitalityNeeds: string;

  // Commercial & compliance
  budget: string;
  pricingModel: string;
  complianceExpectations: string[];
  reportingRequirements: string[];
}

export const initialCustomerIntakeForm: CustomerIntakeForm = {
  name: '',
  sector: '',
  operatingModel: '',
  owner: '',
  sitesCount: '',
  targetGoLive: '',
  userTypes: [],
  serviceTimes: [],
  menus: [],
  dietaryRequirements: [],
  allergens: [],
  hospitalityNeeds: '',
  budget: '',
  pricingModel: '',
  complianceExpectations: [],
  reportingRequirements: [],
};
